import script from "./AsBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./AsBadge.vue?vue&type=script&lang=ts&setup=true"

import "./AsBadge.vue?vue&type=style&index=0&id=eebee5c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eebee5c0"]])

export default __exports__